/* eslint-disable class-methods-use-this */
import analytics from './analytics';

const EVENT = 'StorefrontPageViews';

export class Storefront {

  registryView() {
    analytics.registryEvent({
      event: EVENT,
      action: analytics.getPartnerInfo().name
    });
  }
}

export default new Storefront();



// WEBPACK FOOTER //
// ./src/components/storefront/analytics/storefront.js